module.exports = __webpack_public_path__ + "static/media/banner-capacity-accelerator.cd77dc6a.png";